module.exports = __webpack_public_path__ + "img/tfwlogo.a9b648e6.png";